import React, { useEffect, useState } from 'react';
import ErrorLayout from 'layouts/ErrorLayout';
import Loading from 'components/Loading';
import { useParams } from 'react-router-dom';
import { getPlatformLegal } from './modules/actions';
import './styles.scss';

function Legal() {
  const [legal, setLegal] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { type, lang } = useParams();

  useEffect(() => {
    const fetchLegal = async () => {
      try {
        setLoading(true);
        const auxLegal = await getPlatformLegal(type, lang);
        setLegal(auxLegal);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchLegal();
  }, [type, lang]);

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return <ErrorLayout code={500} />;
  }

  if (!legal) {
    return <ErrorLayout code={404} />;
  }

  return (
    <div className='legal-document' dangerouslySetInnerHTML={{ __html: legal }} />
  );
}

export default Legal;
